import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from 'projects/tools/src/lib/shared/shared.service';
import { HttpClient, HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private sharedService: SharedService
  ) {
    
  }

  ngOnInit(): void {
    if ((localStorage.getItem('userDataRoleBased') !== null && localStorage.getItem('userDataRoleBased') !== '')) {      
      this.sharedService.role.next(localStorage.getItem('role'));
    }
  }

}
